import { render, staticRenderFns } from "./LoadProducts.vue?vue&type=template&id=79ec45e7&scoped=true"
import script from "./LoadProducts.vue?vue&type=script&lang=js"
export * from "./LoadProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ec45e7",
  null
  
)

export default component.exports